import { RouteObject } from 'react-router';
import { HomePage } from './pages';

export const homeRoutes: RouteObject[] = [
  {
    index: true,
    Component: HomePage,
  },
];
